import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { RULE_STARTERS } from '../lib/ruleTemplates';
const RuleStarterPicker = ({ onSelect }) => (
  <div>
    <h5>What would you like this rule to do?</h5>
    <p className="text-muted small">
      Choose a starting point. You can change every detail before saving.
    </p>
    <Row className="g-3">
      {RULE_STARTERS.map(starter => (
        <Col md={6} key={starter.id}>
          <Button
            variant="outline-primary"
            className="w-100 h-100 text-start p-3"
            onClick={() => onSelect(starter.id)}
          >
            <strong className="d-block">{starter.title}</strong>
            <span className="d-block small mt-1">{starter.help}</span>
          </Button>
        </Col>
      ))}
    </Row>
  </div>
);
export default RuleStarterPicker;
